/**
 * @see https://umijs.org/docs/max/access#access
 * 基于角色的访问控制
 */

export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const userRoles = currentUser?.roles || [];
  const isAdmin =
    userRoles.includes('admin') || currentUser?.access === 'admin';

  return {

    canAdmin: isAdmin,

    canUser: !!currentUser,
    userRoles,
  };
}
